<template>
  <div class="wrapper-general-error">
    <img
      src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/404.svg"
      class="icon"
      alt="Error 404"
    />

    <p class="text">Página no encontrada</p>

    <img
      src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/logos/LogoColors.svg"
      class="logo"
      alt="iterrabyte"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorView",
});
</script>

<style scoped lang="scss">
@import "src/ux/pageNotFound/styles/pageNotFoundStyle";
</style>
